import React from "react";
import { Helmet } from "react-helmet";
import { ItemGridDragDropTitleStyle } from "../../components/grid-drag-drop/ItemGridDragDropTitleStyle";
import { Grid, IconButton } from "@material-ui/core";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import { LightTooltip, Margin } from "../../styles/GlobalStyle";
import CachedOutlinedIcon from "@material-ui/icons/CachedOutlined";
import CloseIcon from "@material-ui/icons/Close";
import { DividerStyled } from "../../components/chat/styles/GeneralStyle";
import useDashboardViewController from "../../pages/dashboard/controllers/DashboardViewController";

export const WidgetVersion91 = () => {
  const { handleDeleteWidgets } = useDashboardViewController();

  const item = {
    i: "91",
    importScripts: ["https://app2.weatherwidget.org/js/?id=ww_ef72f3d7b4d4d"],
    stringScripts: [""],
    stringChildren:
      '<head><meta charset="UTF-8" /><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Roboto&display=swap" rel="stylesheet"></head><body style="font-family: "Roboto", sans-serif; margin:20px;"><div style="height: calc(100% - 15px); overflow-y: auto;"><table style="border-collapse: collapse;"><tr style="font-size: 15px; height: 30px;"><th style="width: 150px;">Situação</th><th style="width: 150px; text-align: start;">CNPJ</th><th style="width: 500px; text-align: start;">Nome</th><th style="width: 100px;">UF</th><th style="width: 150px;">Status</th><th style="width: 100px;">Certificado</th><th style="width: 100px;">Validade</th></tr><tbody id="tbody" style="font-size: 12px; color: #7B7B7B;"></tbody></table></div><div style="font-size: 9px; font-weight: bold; display: flex; justify-content: flex-end; padding: 5px;"><div style="width: 3px; height: 10px; background: #FA3A3A 0% 0% no-repeat padding-box; border-radius: 2px;"></div><span style="padding-left: 2px; padding-right: 10px;">Vencido</span><div style="width: 3px; height: 10px; background: #00B955 0% 0% no-repeat padding-box; border-radius: 2px;"></div><span style="padding-left: 2px; padding-right: 10px;">Em dia</span><div style="width: 3px; height: 10px; background: #FED779 0% 0% no-repeat padding-box; border-radius: 2px;"></div><span style="padding-left: 2px; padding-right: 10px;">Próximo de vencer</span><div style="width: 3px; height: 10px; background: #4E1BF7 0% 0% no-repeat padding-box; border-radius: 2px;"></div><span style="padding-left: 2px; padding-right: 10px;">Não enviado</span></div></body>',
    onRefresh:
      "try {var url = 'https://api-microservice.qyon.info/v1/fiscal-intelligence/dashboard/certificate?' + (localStorage.getItem('isAccountantPanel') == 'true' ? 'parentCnpj=' : 'cnpj=') + localStorage.getItem('documentPanel');var requestOptions = {method: 'GET',headers: { 'Authorization': '0893E99C-4AE4-4A83-89E5-1EED31171094' },redirect: 'follow'};fetch(url, requestOptions).then(response => response.text()).then(result => printResult(result)).catch(error => console.log('error', error));const table = document.getElementById('tbody');table.innerHTML = '';function printResult(result) {let obj = JSON.parse(result);obj.list.forEach(item => {var tr = document.createElement('tr');tr.style = 'border-top: #E5E5E5 solid 1px; height: 30px;';tr.appendChild(getSituacao(item.validTo));tr.appendChild(getItem(item.cnpj.length == 14 ? (item.cnpj.substring(0, 2) + '.' + item.cnpj.substring(2, 5) + '.' + item.cnpj.substring(5, 8) + '/' + item.cnpj.substring(8, 12) + '-' + item.cnpj.substring(12)) : item.cnpj));tr.appendChild(getItem(item.name));tr.appendChild(getItem(item.province.substring(3), 'text-align: center;'));tr.appendChild(getItem(item.statusName, 'text-align: center;'));tr.appendChild(getItem(item.certType, 'text-align: center;'));tr.appendChild(getItem(item.validTo ? new Date(item.validTo).toLocaleDateString() : '-', 'text-align: center;'));table.appendChild(tr);});}function getItem(value, style) {var td = document.createElement('td');td.textContent = value;td.style = style;return td;}function getSituacao(validTo) {let color = '#00B955';if (!validTo)color = '#4E1BF7';else if (new Date(validTo) <= new Date())color = '#FA3A3A';else if (new Date(validTo) <= addDays(new Date(), -30))color = '#FED779';var sit = document.createElement('div');sit.style = 'width: 32px; height: 5px; background: ' + color + ' 0% 0% no-repeat padding-box; border-radius: 3px;';var td = document.createElement('td');td.style = 'text-align: center; text-align: -webkit-center;';td.appendChild(sit);return td;}function addDays(date, days) {var result = new Date(date);result.setDate(result.getDate() + days);return result;}} catch (e) {console.log(e)}",
    refreshOnLoad: true,
  };

  return (
    <>
      {item.importScripts.map((script, index) => {
        return (
          <div key={`import_${index}`}>
            <Helmet>
              <script async src={script}></script>
            </Helmet>
          </div>
        );
      })}

      <ItemGridDragDropTitleStyle customStyle={item.headerStyle ?? {}}>
        <Grid item container justifyContent="space-between" alignItems="center">
          <Grid item flex={1}>
            <IconButton size="small">
              <DragIndicatorIcon style={{ fontSize: 18, marginRight: 5 }} />
            </IconButton>
            Certificados
          </Grid>
          <Grid item flex={1}>
            <Grid item container alignItems="center">
              <Margin top="7" />
              {item.onRefresh &&
                (() => {
                  if (item?.refreshOnLoad) {
                    setTimeout(() => {
                      try {
                        // eslint-disable-next-line no-eval
                        eval("try{" + item.onRefresh + "}catch(err){}");
                      } catch (error) {
                        console.error(error);
                      }
                    }, 1500);
                  }

                  return (
                    <Grid item flex={1}>
                      <LightTooltip title="Atualizar">
                        <CachedOutlinedIcon
                          style={{
                            fontSize: 18,
                            marginRight: 10,
                            cursor: "pointer",
                            color: "#636363",
                          }}
                          onClick={() => {
                            // Muito cuidado, o eval é perigoso - https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/eval
                            try {
                              // eslint-disable-next-line no-eval
                              eval("try{" + item.onRefresh + "}catch(err){}");
                            } catch (error) {
                              console.error(error);
                            }
                          }}
                        />
                      </LightTooltip>
                    </Grid>
                  );
                })()}
              <Grid item flex={1}>
                <LightTooltip title="Remover">
                  <CloseIcon
                    style={{
                      fontSize: 18,
                      cursor: "pointer",
                      color: "#636363",
                      marginRight: 10,
                    }}
                    onClick={() => handleDeleteWidgets(item)}
                  />
                </LightTooltip>
              </Grid>
            </Grid>
          </Grid>
          <DividerStyled style={{ width: "100%" }} />
        </Grid>
      </ItemGridDragDropTitleStyle>

      <div
        style={{
          height: `${"calc(100% - 65px)"}`,
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <head>
          <meta charset="UTF-8" />
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link
            rel="preconnect"
            href="https://fonts.gstatic.com"
            crossOrigin="true"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Roboto&display=swap"
            rel="stylesheet"
          />
        </head>
        <body
          style={{
            fontFamily: "Roboto, sans-serif",
            backgroundColor: "white",
          }}
        >
          <div style={{ height: "calc(100% - 15px)" }}>
            <table style={{ borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ fontSize: "15px", height: "30px" }}>
                  <th style={{ width: "150px" }}>Situação</th>
                  <th style={{ width: "150px", textAlign: "start" }}>CNPJ</th>
                  <th style={{ width: "500px", textAlign: "start" }}>Nome</th>
                  <th style={{ width: "100px" }}>UF</th>
                  <th style={{ width: "150px" }}>Status</th>
                  <th style={{ width: "100px" }}>Certificado</th>
                  <th style={{ width: "100px" }}>Validade</th>
                </tr>
              </thead>
              <tbody
                id="tbody"
                style={{ fontSize: "12px", color: "#7B7B7B" }}
              ></tbody>
            </table>
          </div>
          {/* Footer */}
          <div
            style={{
              fontSize: "9px",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
              padding: "5px",
              position: "fixed",
              bottom: "0",
              width: "99%",
            }}
          >
            <div
              style={{
                width: "3px",
                height: "10px",
                background: "#FA3A3A",
                borderRadius: "2px",
              }}
            ></div>
            <span style={{ paddingLeft: "2px", paddingRight: "10px" }}>
              Vencido
            </span>
            <div
              style={{
                width: "3px",
                height: "10px",
                background: "#00B955",
                borderRadius: "2px",
              }}
            ></div>
            <span style={{ paddingLeft: "2px", paddingRight: "10px" }}>
              Em dia
            </span>
            <div
              style={{
                width: "3px",
                height: "10px",
                background: "#FED779",
                borderRadius: "2px",
              }}
            ></div>
            <span style={{ paddingLeft: "2px", paddingRight: "10px" }}>
              Próximo de vencer
            </span>
            <div
              style={{
                width: "3px",
                height: "10px",
                background: "#4E1BF7",
                borderRadius: "2px",
              }}
            ></div>
            <span style={{ paddingLeft: "2px", paddingRight: "10px" }}>
              Não enviado
            </span>
          </div>
        </body>
      </div>

      {item.stringScripts &&
        item.stringScripts.map((script, index) => {
          return (
            <div key={`script_${index}`}>
              <Helmet>
                <script async>{script}</script>
              </Helmet>
            </div>
          );
        })}
    </>
  );
};
